import styled from "styled-components"

import { Caption } from "@assets/styles/typographyStyles"

export const ForgotPasswordText = styled(Caption)`
  color: var(--gray4);
  cursor: pointer;
`
